import type { Locale } from '@appwin/shared';

/** API base URL. Inlined at build time; empty means same-origin (Pages proxy). */
export const API_BASE_URL: string = import.meta.env.VITE_API_BASE_URL ?? '';

export const CATALOG_BASE_URL: string =
  import.meta.env.VITE_CATALOG_BASE_URL ?? 'https://appwin.example.com';

export const CLIENT_DOWNLOAD_URL: string =
  import.meta.env.VITE_CLIENT_DOWNLOAD_URL ?? '/download/appwin-setup.exe';

export function deepLinkFor(appId: string): string {
  return `appwin://install?appId=${encodeURIComponent(appId)}`;
}

export function localePath(locale: Locale, path = '/'): string {
  // English lives at the root; Russian is mirrored under `/ru`.
  const clean = path.startsWith('/') ? path : `/${path}`;
  return locale === 'ru' ? `/ru${clean === '/' ? '' : clean}` || '/ru' : clean;
}

export const OTHER_LOCALE: Record<Locale, Locale> = { en: 'ru', ru: 'en' };
